import { OTPInput, REGEXP_ONLY_DIGITS } from 'input-otp';
import { cn } from '../../utils/cn';
import {
    OTP_SLOT_ACTIVE_CLASS,
    OTP_SLOT_BASE_CLASS,
    OTP_SLOT_DISABLED_CLASS,
    OTP_SLOT_ERROR_CLASS,
} from '../form/formControlStyles';

export type OtpCodeInputProps = {
    id?: string;
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    hasError?: boolean;
    className?: string;
    length?: number;
    'aria-label'?: string;
    'aria-describedby'?: string;
    autoFocus?: boolean;
};

export default function OtpCodeInput({
    id = 'pinCode',
    value,
    onChange,
    disabled = false,
    hasError = false,
    className,
    length = 5,
    'aria-label': ariaLabel = 'Verification code',
    'aria-describedby': ariaDescribedBy,
    autoFocus
}: OtpCodeInputProps) {
    return (
        <OTPInput
            id={id}
            name={id}
            aria-label={ariaLabel}
            aria-invalid={hasError}
            aria-describedby={ariaDescribedBy}
            maxLength={length}
            value={value}
            onChange={onChange}
            disabled={disabled}
            pattern={REGEXP_ONLY_DIGITS}
            inputMode="numeric"
            autoComplete="one-time-code"
            pushPasswordManagerStrategy="increase-width"
            containerClassName={cn("flex overflow-x-hidden w-full",className)}
            data-testid="otp-code-input"
            autoFocus={autoFocus}
            render={({ slots }) => (
                <div
                    className="pointer-events-none flex items-center justify-center gap-3 w-full"
                    aria-hidden
                >
                    {slots.map((slot, index) => (
                        <div
                            key={index}
                            data-testid="otp-code-slot"
                            className={cn(
                                OTP_SLOT_BASE_CLASS,
                                slot.isActive && !hasError && !disabled && OTP_SLOT_ACTIVE_CLASS,
                                hasError && OTP_SLOT_ERROR_CLASS,
                                disabled && OTP_SLOT_DISABLED_CLASS
                            )}
                        >
                            {slot.char !== null ? (
                                <span className="tabular-nums">{slot.char}</span>
                            ) : null}
                            {slot.hasFakeCaret && !disabled ? (
                                <span className="absolute h-5 w-px animate-otp-caret bg-primary" />
                            ) : null}
                        </div>
                    ))}
                </div>
            )}
        />
    );
}
